import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { ScrollTop } from '@graffer-inc/graffer-ui';
import EntryList from '../pages/ems/entry-list';
import EntryDetail from '../pages/ems/entry-detail';
import OpsNotification from '../pages/ems/ops-notification';
import {connect} from "react-redux";
import {setEmsUser} from "../../redux/modules/ems";
import { EmsTemplate } from "@graffer-inc/graffer-ui";

const Main = ({setEmsUser}) => {

  return (
    <EmsTemplate
      baseUrl={process.env.REACT_APP_EMS_BASE_URL}
      hasSideNav
      onAuth={auth => setEmsUser(auth)}
    >
      <ScrollTop>
        <Switch>
          <Route exact path="/ems/entries" component={EntryList} />
          <Route exact path="/ems/entries/:entryId" component={EntryDetail} />
          <Route exact path="/ems/ops-notification" component={OpsNotification} />
          <Redirect from="*" to="/ems/entries" />
        </Switch>
      </ScrollTop>
    </EmsTemplate>
  );
}

export default connect(
  null,
  {setEmsUser}
)(Main);